import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button, Card, Tabs } from "../../components/ui";
import { useAuth } from "../../context/AuthContext";
import { authService, hasAcceptedTerms } from "../../services/auth";
import { useToast } from "../../context/ToastContext";

const PRIVACY = [
  "เราเก็บข้อมูลเท่าที่จำเป็น เช่น อีเมล ชื่อที่แสดง ประวัติการใช้คอยน์ และข้อความแชท เพื่อให้บริการและป้องกันการใช้งานที่ผิดปกติ",
  "ข้อความแชทใช้ประมวลผลเพื่อให้ตัวละคร AI ตอบกลับ และอาจถูกตรวจสอบเมื่อมีการรายงานเนื้อหา",
  "คุณขอดู แก้ไข หรือลบข้อมูลส่วนตัวได้ตาม PDPA โดยติดต่อทีมงาน",
  "ข้อความนี้เป็นร่างเริ่มต้น — ทีมกฎหมายต้องตรวจและแทนที่ก่อนเปิดใช้งานจริง",
];
const TERMS = [
  "ตัวละครและบทสนทนาทั้งหมดเป็นเรื่องแต่งที่สร้างโดย AI ไม่ใช่คำแนะนำทางการแพทย์ กฎหมาย หรือการเงิน",
  "ห้ามสร้างหรือแชร์เนื้อหาที่ผิดกฎหมาย ล่วงละเมิดผู้อื่น หรือใช้รูป/ข้อมูลของบุคคลจริงโดยไม่ได้รับอนุญาต",
  "คอยน์ใช้จ่ายภายในบริการ ไม่สามารถแลกเป็นเงินสด และการเติมเงินสำเร็จแล้วไม่คืนเงิน ยกเว้นกรณีระบบผิดพลาด",
  "ผู้ใช้อายุต่ำกว่า 18 ปีต้องได้รับความยินยอมจากผู้ปกครอง",
  "ข้อความนี้เป็นร่างเริ่มต้น — ทีมกฎหมายต้องตรวจและแทนที่ก่อนเปิดใช้งานจริง",
];

export default function Terms() {
  const { isLoggedIn, profile, refresh } = useAuth();
  const navigate = useNavigate();
  const toast = useToast();
  const [params] = useSearchParams();
  const [tab, setTab] = useState("terms");
  const [agree, setAgree] = useState(false);
  const [loading, setLoading] = useState(false);
  const accepted = hasAcceptedTerms(profile);
  const next = params.get("next") || "/";

  const accept = async () => {
    setLoading(true);
    try {
      await authService.acceptTerms();
      await refresh().catch(() => {});
      navigate(next, { replace: true });
    } catch (err) {
      toast(err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const items = tab === "terms" ? TERMS : PRIVACY;
  return (
    <div style={{ maxWidth: 720, margin: "16px auto 48px", padding: "0 16px", width: "100%" }}>
      <h1 className="mb-16">ข้อกำหนดและความเป็นส่วนตัว</h1>
      <Tabs tabs={[{ value: "terms", label: "ข้อกำหนดและเงื่อนไข" }, { value: "privacy", label: "นโยบายความเป็นส่วนตัว" }]} value={tab} onChange={setTab} />
      <Card className="mt-16">
        <ol className="stack" style={{ paddingLeft: 20, margin: 0 }}>
          {items.map((t) => <li key={t}>{t}</li>)}
        </ol>
      </Card>
      {isLoggedIn && !accepted ? (
        <Card grad className="mt-16">
          <label className="row" style={{ alignItems: "flex-start", cursor: "pointer" }}>
            <input type="checkbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} style={{ width: 20, height: 20, marginTop: 2 }} />
            <span>ฉันอ่านและยอมรับข้อกำหนดและเงื่อนไข รวมถึงนโยบายความเป็นส่วนตัว</span>
          </label>
          <Button variant="primary" block size="lg" className="mt-16" disabled={!agree || loading} onClick={accept}>{loading ? "กำลังบันทึก..." : "ยอมรับและเริ่มใช้งาน"}</Button>
        </Card>
      ) : null}
    </div>
  );
}
